const sessionItems = {
    IngredientList: 'ingredientList',
    Products: 'PRODUCT_OVERVIEW',
}

export default sessionItems